var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-TV"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TV",
    clipPath: "url(#clip-TV)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tv-screen",
    transform: "translate(0.001 12.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M469.334,37.332H42.668a32.1,32.1,0,0,0-32,32V346.664a32.1,32.1,0,0,0,32,32H469.334a32.094,32.094,0,0,0,32-32V69.333A32.093,32.093,0,0,0,469.334,37.332Z",
    fill: "#abb8b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M318.883,378.665H193.119L182.45,432h147.1Z",
    fill: "#fcd051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M329.551,432H170.668a21.394,21.394,0,0,0-21.333,21.333v21.335H362.668V453.332A21.4,21.4,0,0,0,341.333,432Z",
    fill: "#fcd051"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M469.334,26.665H42.668A42.717,42.717,0,0,0,0,69.333V346.665a42.717,42.717,0,0,0,42.668,42.668H180.107l-6.4,32h-3.038a32.036,32.036,0,0,0-32,32v21.335a10.667,10.667,0,0,0,10.667,10.668H362.667a10.667,10.667,0,0,0,10.667-10.668V453.331a32.037,32.037,0,0,0-32-32h-3.037l-6.4-32H469.333A42.716,42.716,0,0,0,512,346.665V69.333A42.715,42.715,0,0,0,469.334,26.665ZM352,453.331V464H160V453.331a10.675,10.675,0,0,1,10.665-10.665H341.332A10.678,10.678,0,0,1,352,453.331Zm-35.461-32H195.463l6.4-32H310.137Zm174.126-74.666A21.357,21.357,0,0,1,469.334,368H42.668a21.357,21.357,0,0,1-21.333-21.333V69.333A21.357,21.357,0,0,1,42.668,48H469.334a21.357,21.357,0,0,1,21.331,21.333V346.665Z",
    fill: "#000003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M53.333,271.117a10.668,10.668,0,0,0-10.667,10.668V336A10.667,10.667,0,0,0,64,336V281.785A10.667,10.667,0,0,0,53.333,271.117Z",
    fill: "#000003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M53.329,261.806A10.667,10.667,0,0,0,64,251.139v-.252a10.667,10.667,0,0,0-21.334,0v.252A10.667,10.667,0,0,0,53.329,261.806Z",
    fill: "#000003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M458.663,154.192a10.667,10.667,0,0,0-10.668,10.667v.252a10.667,10.667,0,0,0,21.335,0v-.252A10.666,10.666,0,0,0,458.663,154.192Z",
    fill: "#000003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M458.667,69.331A10.667,10.667,0,0,0,448,80v54.214a10.667,10.667,0,1,0,21.335,0V80A10.669,10.669,0,0,0,458.667,69.331Z",
    fill: "#000003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M362.979,159.444c-11.536-11.474-27.7-17.293-48.039-17.293H282.7a10.667,10.667,0,0,0-10.559,9.153L256.3,261.665a10.667,10.667,0,0,0,10.559,12.182h40.371c25.92,0,45.642-8.184,58.617-24.321,11.328-14.086,16.28-31.815,14.321-51.267C378.56,182.246,372.775,169.185,362.979,159.444Zm-13.754,76.712c-8.848,11.005-22.583,16.355-41.989,16.355H279.172l12.776-89.026h22.994c14.7,0,25.495,3.625,32.995,11.087,6.288,6.252,9.89,14.7,11.01,25.825C360.332,214.161,356.972,226.525,349.225,236.156Z",
    fill: "#000003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M237.955,142.258a10.672,10.672,0,0,0-12.064,9.059l-6.544,46.012H162.309l6.17-42.995a10.667,10.667,0,1,0-21.118-3.028L131.523,261.667a10.666,10.666,0,0,0,9.044,12.073,10.846,10.846,0,0,0,1.529.11,10.67,10.67,0,0,0,10.546-9.155l6.6-46.03h57.066L210.2,261.678a10.668,10.668,0,1,0,21.123,3.005l15.7-110.361A10.666,10.666,0,0,0,237.955,142.258Z",
    fill: "#000003"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.c42fadabe9dcf6bdcf9a2d997841a062.svg";
export { ForwardRef as ReactComponent };